import insertInArrayIf from '@zola-helpers/client/dist/es/util/insertInArrayIf';
import { CategoryTiles } from '@zola/zola-ui/src/components/PreAuthV3';
import { StyledH3 } from '@zola/zola-ui/src/components/PreAuthV3/CategoryTiles.styles';
import { useResponsiveDesign } from '@zola/zola-ui/src/contexts/ResponsiveDesignContext/ResponsiveDesignContext';
import { FONT } from '@zola/zola-ui/src/styles/emotion';
import MEDIA_QUERY_V2 from '@zola/zola-ui/src/styles/emotion/mediaQueryV2';

import styled from '@emotion/styled';

import POPULAR_ATLANTA from '~/pages/couples/explore/assets/popular-atlanta.jpg';
import POPULAR_AUSTIN from '~/pages/couples/explore/assets/popular-austin.jpg';
import POPULAR_BOSTON from '~/pages/couples/explore/assets/popular-boston.jpg';
import POPULAR_CHICAGO from '~/pages/couples/explore/assets/popular-chicago.jpg';
import POPULAR_DALLAS from '~/pages/couples/explore/assets/popular-dallas.jpg';
import POPULAR_DENVER from '~/pages/couples/explore/assets/popular-denver.jpg';
import POPULAR_LOS_ANGELES from '~/pages/couples/explore/assets/popular-los-angeles.jpg';
import POPULAR_MIAMI from '~/pages/couples/explore/assets/popular-miami.jpg';
import POPULAR_NEW_YORK from '~/pages/couples/explore/assets/popular-new-york.jpg';
import POPULAR_PHILADELPHIA from '~/pages/couples/explore/assets/popular-philadelphia.jpg';
import POPULAR_PHOENIX from '~/pages/couples/explore/assets/popular-phoenix.jpg';
import POPULAR_SAN_DIEGO from '~/pages/couples/explore/assets/popular-san-diego.jpg';
import POPULAR_SAN_FRANCISCO from '~/pages/couples/explore/assets/popular-san-francisco.jpg';
import POPULAR_SEATTLE from '~/pages/couples/explore/assets/popular-seattle.jpg';
import POPULAR_TAMPA from '~/pages/couples/explore/assets/popular-tampa.jpg';
import POPULAR_WASHINGTON_DC from '~/pages/couples/explore/assets/popular-washington-dc.jpg';
import { getAssetImageUrl } from '~/util/imageUtils';

const StyledCategoryTiles = styled(CategoryTiles)`
  ${StyledH3} {
    ${MEDIA_QUERY_V2.MOBILE} {
      ${FONT.textSizeUltraCompact(FONT.SIZE.LARGE)};
    }
  }
`;

const PopularLocations = ({ isClpTest }: { isClpTest: boolean }) => {
  const { isMobile, isTablet } = useResponsiveDesign();
  return (
    <StyledCategoryTiles
      title="Popular locations"
      cta={{
        linkText: 'Get started',
        href: '/inspiration/onboard',
        displayAsButton: true,
      }}
      tileButtonTextTransform={false}
      square={isMobile || isTablet}
      categories={[
        {
          image: getAssetImageUrl(POPULAR_NEW_YORK, { width: 220, quality: 80 }),
          altText: '',
          linkText: 'New York',
          href: '/wedding-vendors/search/new-york-ny',
        },
        {
          image: getAssetImageUrl(POPULAR_CHICAGO, { width: 220, quality: 80 }),
          altText: '',
          linkText: 'Chicago',
          href: '/wedding-vendors/search/chicago-il',
        },
        {
          image: getAssetImageUrl(POPULAR_LOS_ANGELES, { width: 220, quality: 80 }),
          altText: '',
          linkText: 'Los Angeles',
          href: '/wedding-vendors/search/los-angeles-ca',
        },
        {
          image: getAssetImageUrl(POPULAR_PHILADELPHIA, { width: 220, quality: 80 }),
          altText: '',
          linkText: 'Philadelphia',
          href: '/wedding-vendors/search/philadelphia-pa',
        },
        {
          image: getAssetImageUrl(POPULAR_DALLAS, { width: 220, quality: 80 }),
          altText: '',
          linkText: 'Dallas',
          href: '/wedding-vendors/search/dallas-tx',
        },
        {
          image: getAssetImageUrl(POPULAR_MIAMI, { width: 220, quality: 80 }),
          altText: '',
          linkText: 'Miami',
          href: '/wedding-vendors/search/miami-fl',
        },
        ...insertInArrayIf(
          isClpTest,
          ...[
            {
              image: getAssetImageUrl(POPULAR_SAN_DIEGO, { width: 220, quality: 80 }),
              altText: '',
              linkText: 'San Diego',
              href: '/wedding-vendors/search/san-diego-ca',
            },
            {
              image: getAssetImageUrl(POPULAR_SAN_FRANCISCO, { width: 220, quality: 80 }),
              altText: '',
              linkText: 'San Francisco',
              href: '/wedding-vendors/search/san-francisco-ca',
            },
            {
              image: getAssetImageUrl(POPULAR_DENVER, { width: 220, quality: 80 }),
              altText: '',
              linkText: 'Denver',
              href: '/wedding-vendors/search/denver-co',
            },
            {
              image: getAssetImageUrl(POPULAR_TAMPA, { width: 220, quality: 80 }),
              altText: '',
              linkText: 'Tampa',
              href: '/wedding-vendors/search/tampa-fl',
            },
            {
              image: getAssetImageUrl(POPULAR_WASHINGTON_DC, { width: 220, quality: 80 }),
              altText: '',
              linkText: 'Washington DC',
              href: '/wedding-vendors/search/washington-dc',
            },
            {
              image: getAssetImageUrl(POPULAR_PHOENIX, { width: 220, quality: 80 }),
              altText: '',
              linkText: 'Phoenix',
              href: '/wedding-vendors/search/phoenix-az',
            },
            {
              image: getAssetImageUrl(POPULAR_SEATTLE, { width: 220, quality: 80 }),
              altText: '',
              linkText: 'Seattle',
              href: '/wedding-vendors/search/seattle-wa',
            },
            {
              image: getAssetImageUrl(POPULAR_BOSTON, { width: 220, quality: 80 }),
              altText: '',
              linkText: 'Boston',
              href: '/wedding-vendors/search/boston-ma',
            },
            {
              image: getAssetImageUrl(POPULAR_AUSTIN, { width: 220, quality: 80 }),
              altText: '',
              linkText: 'Austin',
              href: '/wedding-vendors/search/austin-tx',
            },
            {
              image: getAssetImageUrl(POPULAR_ATLANTA, { width: 220, quality: 80 }),
              altText: '',
              linkText: 'Atlanta',
              href: '/wedding-vendors/search/atlanta-ga',
            },
          ]
        ),
      ]}
    />
  );
};

export default PopularLocations;
